module.exports = __webpack_public_path__ + "static/media/mute_sky.0cc5a4c8.svg";